/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocXIcon16Solid = forwardRef('DocXIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1H8v3.5A1.5 1.5 0 0 0 9.5 6H13v6.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 12.5v-9A2.5 2.5 0 0 1 4.5 1Zm5.12 7.774a.625.625 0 0 0-.883-.884L7.5 9.127 6.263 7.89a.625.625 0 1 0-.884.884l1.237 1.237-1.237 1.237a.625.625 0 1 0 .884.884L7.5 10.895l1.237 1.237a.625.625 0 1 0 .884-.884L8.384 10.01 9.62 8.774Z" }),
        React.createElement("path", { d: "M13 4.99V5H9.5a.5.5 0 0 1-.5-.5V1h.01L13 4.99Z" })));
});
